import { render } from "./pos-mobile.vue?vue&type=template&id=be345f4a&scoped=true"
import script from "./pos-mobile.vue?vue&type=script&lang=js"
export * from "./pos-mobile.vue?vue&type=script&lang=js"

import "./pos-mobile.vue?vue&type=style&index=0&id=be345f4a&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be345f4a"]])

export default __exports__